import React from 'react';
import Box from 'grommet/components/Box';
import FormField from 'grommet/components/FormField';
import Select from 'grommet/components/Select';
import Button from 'grommet/components/Button';
import Table from 'grommet/components/Table';
import TextInput from 'grommet/components/TextInput';
import Paragraph from 'grommet/components/Paragraph';
import * as Constants from '../Redux/action_types/EPAConstants.js';

const DataDrive = (props) => {
       const { Drives, dataDiskValue, type, title, onDataDiskChange, noOfDisksValue, onNoOfDisksChange, dataDriveType, onDatadriveTypeChange, renderTable, onAddingDataDisk, dataDriveConsolidatedOptions, isMixedStorage, enableADDButton, driveChangeMethodParam1, driveQtyChangeMethodParam1, roleName, workloadType, isEPIC} = props
       let driveTypeLabel = "Data Drive Type";
       let driveLabel = 'Data Disk';
       let drivesQuantityLabel = 'No. of Data Disks';

       const onDriveChange = (e) => {
              if(workloadType === Constants.BIG_DATA) {
                     onDataDiskChange(e, type, title);
              }
              if(workloadType === Constants.HPE_CP) {
                     onDataDiskChange(e, driveChangeMethodParam1, roleName);
              }
       }
       const onDriveQtyChange = (e, ChorBlur) => {
              if(workloadType === Constants.BIG_DATA) {
                     if(ChorBlur === Constants.CHANGE){
                            onNoOfDisksChange(e, type, title, Constants.CHANGE);
                     } else if(ChorBlur === Constants.BLUR) {
                            onNoOfDisksChange(e, type, title, Constants.BLUR);
                     }
              }
              if(workloadType === Constants.HPE_CP) {
                     if(ChorBlur === Constants.CHANGE){
                            onNoOfDisksChange(e, driveQtyChangeMethodParam1, Constants.CHANGE);
                     } else if(ChorBlur === Constants.BLUR) {
                            onNoOfDisksChange(e, driveQtyChangeMethodParam1, Constants.BLUR)
                     }
              }
       }

       if (workloadType === Constants.HPE_CP) {
                     driveTypeLabel = "Persistent Drive Type";
                     driveLabel = 'Persistent Drive';
                     drivesQuantityLabel = 'No. of Persistent Drives';
       }
       
       return (
              <Box>
                     <Box style={{ alignItems : "center"}}>{isMixedStorage === "True"? '' : <Paragraph><b>Click on Add to go with mixed storage configuration</b></Paragraph>}</Box>
                     <Box direction='row' pad={{ between: 'small' }}>
                            <FormField className="DiskCapacityDetails" label={driveTypeLabel}>
                                   <Select value={dataDriveType} options={dataDriveConsolidatedOptions} onChange={(e)=>onDatadriveTypeChange(e)}/>
                            </FormField>
                            <FormField className="DiskCapacityDetails" label={driveLabel} /*error={this.state.DiskCapacityerror}*/ >
                                   <Select placeHolder='None' options={Drives} value={dataDiskValue} onChange={(e) => onDriveChange(e)} />
                            </FormField>
                            <FormField className="DiskCapacityDetails" label={drivesQuantityLabel}>
                                   <TextInput placeHolder='None' value={noOfDisksValue} onDOMChange={(e) => onDriveQtyChange(e, Constants.CHANGE)} onBlur={(e) => onDriveQtyChange(e,Constants.BLUR)} /> 
                            </FormField>
                            { enableADDButton ?
                            <Button style={{margin : '14px 0px', padding: '8px 13px'}} primary={true} onClick={(e) => onAddingDataDisk()}>ADD</Button> :
                            <Button style={{margin : '14px 0px', padding: '8px 13px'}} primary={true}>ADD</Button> }
                     </Box>
                     {isMixedStorage === "True" ?
                     <Box>
                            <Table style={{ width: '80%', margin: 'auto' }}>
                                   <thead>
                                          <tr>
                                                 <th><b>Drive</b></th>
                                                 <th><b>Drive Quantity</b></th>
                                                 <th></th>
                                          </tr>
                                   </thead>
                                   <tbody>
                                          {renderTable()}
                                   </tbody>
                            </Table>
                            {workloadType === Constants.HPE_CP ? 
                            <Paragraph style={{color:'red', fontWeight: '600'}}>Note: All Mixed Storage Configurations have to be deleted to change server selection.</Paragraph> 
                            : ''}
                     </Box>:
                            ''
                     }
              </Box>
       )
}

export default DataDrive;






// WEBPACK FOOTER //
// ./src/SizerUI/SizerScreens/DataDrive.js